<template>
    <tbody> 
        <tr v-if="zero_active && sumvalue(account) == false" :style="(account.account_type != 'ledger') ? 'font-weight: bold' : ''">
            <td v-if="code_active" :style="nodeMargin+' text-transform: uppercase;'"> {{ account.name }} [{{ account.code }}] </td>
            <td v-else :style="nodeMargin+' text-transform: uppercase;'">  {{ account.name }}</td>
            <td class="text-right" style="text-align: right;">{{ formatNumberWithDecimals(account.balance, 2) }}</td>
        </tr>

        <tr v-else-if="sumvalue(account)" :style="(account.account_type != 'ledger') ? 'font-weight: bold' : ''">
            <td v-if="code_active" :style="nodeMargin+' text-transform: uppercase;'">{{ account.name }} [{{ account.code }}] </td>
            <td v-else :style="nodeMargin+' text-transform: uppercase;'">  {{ account.name }}</td>
            <td class="text-right" style="text-align: right;">{{ formatNumberWithDecimals(account.balance, 2) }}</td>
        </tr>
    </tbody>               
    <AccountProfitLoss v-if="hasChildren" v-for="(child, c) in account.children" :key="c" :account="child" :level="(level + 1)" :spaces="(spaces + 15)" :code_active="showCode" :zero_active="showZeroRow"></AccountProfitLoss>
</template>

<script>

    export default {
        name: 'AccountProfitLoss',
        emit:['add-child', 'edit-item', 'delete-item'],
        props: {
            account: {
                type: Object,
                required: true,
            },
            level: {
                type: Number,
                default: 0,
            },
            spaces: {
                type: Number,
                default: 0,
            },
            code_active: {
                type: Boolean,
                default: false,
            },
            zero_active: {
                type: Boolean,
                default: false,
            }

        },
        data() {
            return {
                showChildren: true,
            }
        },
        computed: {
            accountLevel() {
                return this.level;
            },

            nodeMargin() {
                return 'padding-left: '+`${this.spaces}px;`;
            },

            hasChildren() {
                const { children } = this.account;
                return children && children.length > 0
            },

            toggleChildrenIcon() {
                return this.showChildren ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-left';
            },
            showCode() {
                if(this.code_active) {
                    return true;
                }else{
                    return false;
                }
            },
            showZeroRow() {
                if(this.zero_active) {
                    return true;
                }else{
                    return false;
                }
            }

            
        },
        methods: {
            toggleChildren() {
                this.showChildren = !this.showChildren;
            },            
            sumvalue(account){
                let sumVal = Number(parseFloat(account.balance ?? 0)).toFixed(3);
                if(sumVal == '0.000' || sumVal == '-0.000') {
                    return false;
                }else{
                    return true;
                }
            }
        }
    }

</script>
 